<template>
	<div class="con">
		<div class="con1 fl_r fl_j_s fl_a_c">
			<img class="con1_l" src="../../assets/47.png" />
			<div class="con1_c">绍兴零工网</div>
			<div class="con1_r">找工作 来绍兴零工网</div>
			<div class="con1_rs" @click="godetails()">绍兴零工网</div>
		</div>
		<div class="con2s">
			<div class="con2 fl_r fl_j_b fl_a_c">
				<div class="con2_l">
					<div class="con2_l_b fl_r fl_j_s fl_a_c">
						<input placeholder="关键词搜索" v-model="value" class="con2_l_b_l"></input>
						<div class="con2_l_b_r" @click="ssfn()"> 搜索 </div>
					</div>
				</div>
				<div class="con2_r fl_r fl_j_s fl_a_c">
					<img class="con2_r_l" src="../../assets/48.jpg" />
					<div class="con2_r_r">
						<div class="con2_r_r_t">微信扫码小程序</div>
						<div class="con2_r_r_b">好机会随时聊</div>
					</div>
				</div>
			</div>
			<div class="con3 fl_r fl_j_c fl_a_c">
				<div class="con3_l">
					<swiper ref="mySwiper" @slideChange="slideChange" :options="option" class="home-medical-box">
						<swiper-slide v-for="(x,y) in list" :key="y">
							<img :src="`${imghttps(x.url)}`" class="con3_i">
						</swiper-slide>
					</swiper>
				</div>
				<div class="con3_r">
					<div :class="[indexs == y ? 'con3_r_i_active con3_r_i fl_r fl_j_s fl_a_c':'con3_r_i fl_r fl_j_s fl_a_c']" v-for="(x,y) in list" :key="y" @click="change(y)">
						<img :src="`${imghttps(x.url)}`" class="con3_r_i_l" />
						<div class="con3_r_i_r">{{x.name}}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="con4">
			<div class="con4_t fl_r fl_j_s fl_a_e">
				<div class="con4_t_l">
					<div class="con4_t_l_bg"></div>
					<div class="con4_t_l_t">最新岗位</div>
				</div>
				<div class="con4_t_r">随时随地找工作</div>
			</div>
			<div class="con4_b fl_r fl_j_b fl_a_s">
				<div class="con4_b_i" v-for="(x,y) in listjob" :key="y" @click="godetail(x.id)">
					<div class="con4_b_i_t fl_r fl_j_b fl_a_c">
						<div class="con4_b_i_t_l fl_r fl_j_s fl_a_c">
							<div class="con4_b_i_t_l_l" v-if="x.xl == '兼职'">
								<img :src="`${imghttp('49.png')}`" />
							</div>
							<div class="con4_b_i_t_l_c"> {{x.name}} </div>
						</div>
						<div class="con4_b_i_t_r">{{x.wages}}{{x.wages != '面议' && x.wages != '日结' && x.wages != '周结' && x.wages != '月结' && x.wages != '不限' ? '/月':'' }}</div>
					</div>
					<div class="con4_b_i_c fl_r fl_j_s fl_a_c">
						<div class="con4_b_i_c_l"> {{x.ssgsname}} </div>
						<div class="con4_b_i_c_r" v-if="x.qygm != null && x.qygm != ''"> {{x.qygm}}人 </div>
					</div>
					<div class="con4_b_i_b fl_r fl_j_s fl_a_c">
						<div class="con4_b_i_b_i" v-if="x.sshy != null">{{x.sshy}}</div>
						<div class="con4_b_i_b_i" v-if="x.xl != null">{{x.xl}}</div>
					</div>
					<div class="con4_b_i_bs fl_r fl_j_b fl_a_c">
						<div class="con4_b_i_bs_l fl_r fl_j_s fl_a_c">
							<img class="con4_b_i_bs_l_l" v-if="x.lxrtx == null || x.lxrtx == ''" :src="`${imghttp('106.png')}`" />
							<img class="con4_b_i_bs_l_l" v-else :src="`${imghttps(x.lxrtx)}`">
							<div class="con4_b_i_bs_l_c">
								{{x.lxr}}{{x.lxrzw != null ? '·':''}}{{x.lxrzw || ''}}
							</div>
							<div class="con4_b_i_bs_l_r" v-if="x.qytag == 'vip'">
								<img :src="`${imghttp('48.png')}`">
							</div>
						</div>
						<div class="con4_b_i_bs_r line1">{{x.ssgsadd}}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="con4" style="margin:0 auto;margin-top:30px;">
			<div class="con4_t fl_r fl_j_s fl_a_e">
				<div class="con4_t_l">
					<div class="con4_t_l_bg"></div>
					<div class="con4_t_l_t">知名企业</div>
				</div>
				<div class="con4_t_r">精心挑选，优质企业</div>
			</div>
			<div class="con4_bs fl_r fl_j_s fl_a_s">
				<div class="con4_bs_i" v-for="(x,y) in listgs" :key="y">
					<img class="con4_bs_i_t" :src="`${imghttps(x.cppic)}`" />
					<div class="con4_bs_i_c line1">{{x.cpname}}</div>
					<div class="con4_bs_i_b fl_r fl_j_b fl_a_c">
						<div class="con4_bs_i_b_l line1">{{x.cpaddr}}</div>
						<div class="con4_bs_i_b_r">{{x.sshy}}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="con4">
			<div class="con4_t fl_r fl_j_s fl_a_e">
				<div class="con4_t_l">
					<div class="con4_t_l_bg"></div>
					<div class="con4_t_l_t">最新人才</div>
				</div>
				<div class="con4_t_r">优质人才随心挑</div>
			</div>
			<div class="con4_bss fl_r fl_j_b fl_a_s">
				<div class="con4_bss_i fl_r fl_j_b fl_a_c" v-for="(x,y) in listrc" :key="y">
					<div class="con4_bss_i_l">
						<div class="con4_bss_i_l_t">{{x.name || '未知'}}</div>
						<div class="con4_bss_i_l_c">{{x.age|| '未知'}}·{{x.xueli|| '未知'}}·{{x.gzjy || '未知'}}</div>
						<div class="con4_bss_i_l_c">{{x.Hometown}}</div>
						<div class="con4_bss_i_l_b fl_r fl_j_s fl_a_c">
							<img src="../../assets/3.png" class="con4_bss_i_l_b_l" />
							<div class="con4_bss_i_l_b_r">期望职位：{{x.qwzw|| '未知'}}</div>
						</div>
					</div>
					<img class="con4_bss_i_r" v-if="x.sex == '男'" :src="`${imghttp('53.png')}`" />
					<img class="con4_bss_i_r" v-else :src="`${imghttp('69.png')}`" />
				</div>
			</div>
		</div>
		<div class="con4">
			<div class="con4_t fl_r fl_j_s fl_a_e">
				<div class="con4_t_l">
					<div class="con4_t_l_bg"></div>
					<div class="con4_t_l_t">零工市场</div>
				</div>
				<div class="con4_t_r">参加市场招聘增加就业机会</div>
			</div>
			<div class="con4_bsss">
				<div class="con4_bsss_t fl_r fl_j_s fl_a_c">
					<div :class="[scindex == y ? 'con4_bsss_t_i con4_bsss_t_i_active':'con4_bsss_t_i ']" v-for="(x,y) in listsc" :key="y" @click="changesc(y)">
						<div class="con4_bsss_ts">{{x.scname}}</div>
						<div class="con4_bsss_line"></div>
					</div>
				</div>
				<div class="con4_bsss_b">
					<div class="con4_bsss_b_t">
						{{listsc[scindex] ? listsc[scindex].addr :''}}
					</div>
					<div class="con4_bsss_b_b fl_r fl_j_s fl_a_c">
						<div class="con4_bsss_b_b_l" id="container">
						</div>
						<div class="con4_bsss_b_b_r">
							<div class="con4_bsss_b_b_r_t fl_r fl_j_c fl_a_c">
								<div class="con4_bsss_b_b_r_t_l"></div>
								<div class="con4_bsss_b_b_r_t_c">欢迎来电（微信）咨询</div>
								<div class="con4_bsss_b_b_r_t_r"></div>
							</div>
							<div class="con4_bsss_b_b_r_sss fl_r fl_j_c fl_a_c">
								<img class="con4_bsss_b_b_r_sss_l" src="../../assets/4.png" />
								<div class="con4_bsss_b_b_r_sss_r">求职热线：<span>19883593176 </span></div>
							</div>
							<div class="con4_bsss_b_b_r_sss fl_r fl_j_c fl_a_c">
								<img class="con4_bsss_b_b_r_sss_l" src="../../assets/4.png" />
								<div class="con4_bsss_b_b_r_sss_r">招工热线：<span>0575-81199729</span></div>
							</div>
							<img class="con4_bsss_b_b_r_ss" :src="`${imghttps(kf.kfwx)}`" />
							<div class="con4_bsss_b_b_r_ssss">工作时间：{{kf.sbsj}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div style="width:100%;height:100px;"></div>
		<div class="con7">
			<div class="con7_i">
				<img class="con7_i_t" src="../../assets/48.jpg" />
				<div class="con7_i_b">微信小程序</div>
			</div>
			<div class="con7_i">
				<img class="con7_i_t" :src="`${imghttps(kf.kfwx)}`" />
				<div class="con7_i_b">微信客服</div>
			</div>
		</div>
		<footers></footers>
	</div>
</template>
<script>
	let map = null
	import Nav from '@/components/nav.vue'
	import footers from '@/components/footers.vue'
	import sousuo from '@/components/sousuo.vue'
	import listitem from '@/components/listitem.vue'
	import listitems from '@/components/listitems.vue'
	import { swiper, swiperSlide } from 'vue-awesome-swiper'
	import 'swiper/dist/css/swiper.css'
	import axios from "axios";
	export default {
		components: {
			footers,
			Nav,
			swiper,
			swiperSlide,
			sousuo,
			listitem,
			listitems
		},
		name: 'Home',
		data () {
			return {
				scindex: 0,
				value: '',
				listrc: [],
				listjob: [],
				linklist: [],
				listsc: [],
				listgs: [],
				kf: {},
				list: [],
				option: {
					slidesPerView: 1, //显示slide的数量
					centeredSlides: true, //居中显示
					// loop: true, //循环
					initialSlide: 0, //初始索引
					on: {
						click: function (e) {
							console.log(e)
							// 获取点击的索引.
							// 此处可自定义点击事件,注意此处this指向swiper,定义_this
						},
					},
				},
				indexs: 0,
			}
		},
		created () {
			this.getbannber()
			this.queryCompanysfn()
			this.getqueryCompanys()
			this.getrc()
			this.getsc()
			this.getkf()
		},
		mounted () {},
		methods: {
			godetails () {
				this.$router.push({ path: './details' })
			},
			godetail (id) {
				this.$router.push({ path: './detail', query: { id: id } })
			},
			changesc (index) {
				this.scindex = index
				this.openmap(this.listsc[index].addr)
			},
			openmap (data) {
				// map.centerAndZoom(new BMap.Point(116.404, 39.915), 11);
				// 创建地址解析器实例     
				map = new BMap.Map("container");
				let myGeo = new BMap.Geocoder();
				// 将地址解析结果显示在地图上，并调整地图视野  
				myGeo.getPoint(data, function (point) {
					if (point) {
						map.centerAndZoom(point, 16);
						map.addOverlay(new BMap.Marker(point));
					}
				}, "绍兴市");
			},
			getkf () {
				const _this = this
				axios.get("https://xcx.sxlgw.cn:891/system/kfxx/listKf", ).then(function (res) {
					_this.kf = res.data.rows[0]
				}).catch(function (error) {})
			},
			getsc () {
				const _this = this
				axios.get("https://xcx.sxlgw.cn:891/system/scwdgl/listXcx", ).then(function (res) {
					_this.listsc = res.data.rows
					_this.openmap(_this.listsc[0].addr)
				}).catch(function (error) {})
			},
			getrc () {
				const _this = this
				let params = {
					con: '',
					num: 1,
					rows: 6,
					hometown: '',
					// ifjz: this.froms.ifjz,
					qwzw: '',
					// sshy: this.froms.sshy,
					qwgz: '',
					xl: '',
					gzjy: '',
				}
				axios.get("https://xcx.sxlgw.cn:891/system/rcxx/queryQzzs", { params: params }).then(function (res) {
					_this.listrc = res.data.rows
				}).catch(function (error) {})
			},
			getqueryCompanys () {
				const _this = this
				let params = {
					name: '',
					num: 1,
					rows: 10,
				}
				axios.get("https://xcx.sxlgw.cn:891/system/company/queryCompanys", { params: params }).then(function (res) {
					_this.listgs = res.data.rows
				}).catch(function (error) {})
			},
			queryCompanysfn () {
				let params = {
					conlist: this.value,
					num: 1,
					rows: 6,
					tag: '',
					sssc: '',
					ifjz: '',
					ssgw: '',
					sshy: '',
					wages: '',
					xl: '',
					gzjy: '',
					gwxz: '',
					gzqy: '',
				}
				const _this = this
				axios.get("https://xcx.sxlgw.cn:891/system/pinfo/queryPosts3", { params: params }).then(function (res) {
					console.log(res)
					_this.listjob = res.data.rows
				}).catch(function (error) {})
			},
			change (index) {
				this.indexs = index
				this.$refs.mySwiper.swiper.activeIndex = index
			},
			getbannber () {
				const _this = this
				axios.get("https://xcx.sxlgw.cn:891/system/ban/list2").then(function (res) {
					_this.list = res.data.rows
				}).catch(function (error) {})
			},
			goweb (url) {
				window.open(url)
			},
			changtabs (index) {
				this.tablist.forEach((x, y) => {
					x.active = false
				})
				this.tablist[index].active = true
			},
			ssfn (e) {
				console.log(e)
				this.listjob = []
				this.queryCompanysfn()
			},
			slideChange (index) {
				this.indexs = this.$refs.mySwiper.swiper.activeIndex
			},
			tabchange (e) {
				console.log(e)
			}
		}
	};
</script>
<style lang="less" scoped>
	.con7 {
		position: fixed;
		right: 0px;
		top: 200px;
		width: 158px;
		height: 319px;
		background: #FFFFFF;
		box-shadow: 0px 8px 10px 0px rgba(0, 0, 0, 0.1);
		z-index: 9;

		.con7_i {
			width: 160px;
			height: 134px;
			border-bottom: 1px solid rgba(0, 0, 0, .11);

			.con7_i_t {
				width: 80px;
				height: 80px;
				display: block;
				margin: 0 auto;
				margin-top: 25px;
			}

			.con7_i_b {
				width: 100%;
				font-family: Source Han Sans CN, Source Han Sans CN;
				font-weight: 500;
				font-size: 11px;
				color: #000000;
				line-height: 11px;
				text-align: center;
				padding-top: 5px;
			}
		}
	}

	.con4_bx {
		width: 1240px;
		margin: 0 auto;
		margin-top: 50px;

		.con4_bx_i {
			width: 300px;
			margin-right: 30px;

			.con4_bx_i_t {
				width: 300px;
				height: 200px;
				background-color: #fff;

				// width: auto;
				// height: auto;
				// max-width: 100%;
				// max-height: 100%;
				img {
					width: auto;
					height: auto;
					max-width: 100%;
					max-height: 100%;
					display: block;
				}
			}

			.con4_bx_i_t {}

			.con4_bx_i_b {
				width: 100%;
				font-family: Inter, Inter;
				font-weight: normal;
				font-size: 14px;
				color: #000000;
				line-height: 14px;
				text-align: center;
				padding-top: 20px;
			}
		}
	}

	// 	// width: 0;
	// 	height: 4px;
	// }
	.con4_bsss_b_b_r {
		width: 564px;
		height: 575px;
		background: #FFFFFF;
		border-radius: 20px 20px 20px 20px;
		margin-left: 20px;
		overflow: hidden;

		.con4_bsss_b_b_r_t {
			margin-top: 54px;

			.con4_bsss_b_b_r_t_l {
				width: 30px;
				height: 1px;
				background: #33CC99;
				border-radius: 0px 0px 0px 0px;
			}

			.con4_bsss_b_b_r_t_c {
				font-family: Source Han Sans CN, Source Han Sans CN;
				font-weight: bold;
				font-size: 17px;
				color: #555555;
				line-height: 17px;
				text-align: center;
				padding-left: 24px;
				padding-right: 24px;
			}

			.con4_bsss_b_b_r_t_r {
				width: 30px;
				height: 1px;
				background: #33CC99;
				border-radius: 0px 0px 0px 0px;
			}
		}

		.con4_bsss_b_b_r_ss {
			width: 187px;
			height: 187px;
			display: block;
			margin: 0 auto;
			margin-top: 30px;
		}

		.con4_bsss_b_b_r_sss {
			margin-top: 30px;

			.con4_bsss_b_b_r_sss_l {
				width: 29px;
				height: 27px;
				display: block;
			}

			.con4_bsss_b_b_r_sss_r {
				font-family: Source Han Sans CN, Source Han Sans CN;
				font-weight: bold;
				font-size: 18px;
				color: #555555;
				line-height: 18px;

				span {
					font-family: Source Han Sans CN, Source Han Sans CN;
					font-weight: bold;
					font-size: 28px;
					color: #555555;
					line-height: 28px;
				}
			}
		}

		.con4_bsss_b_b_r_ssss {
			width: 100%;
			padding-top: 30px;
			font-family: Source Han Sans CN, Source Han Sans CN;
			font-weight: 500;
			font-size: 18px;
			color: #555555;
			line-height: 18px;
			text-align: center;
		}
	}

	.con4 {
		width: 1240px;
		margin: 0 auto;
		margin-top: 90px;

		.con4_t {
			width: 100%;

			.con4_t_l {
				position: relative;

				.con4_t_l_bg {
					width: 150px;
					height: 26px;
					display: block;
					background: url('../../assets/2.png') no-repeat;
					background-size: 100%;
					position: absolute;
					z-index: -1;
					top: 25px;
					left: 5px;
				}

				.con4_t_l_t {
					font-family: Inter, Inter;
					font-weight: bold;
					font-size: 40px;
					color: #000000;
					line-height: 40px;
				}
			}

			.con4_t_r {
				font-family: Inter, Inter;
				font-weight: 500;
				font-size: 14px;
				color: #9B9E9B;
				line-height: 14px;
				padding-left: 20px;
			}
		}

		.con4_b {
			width: 1240px;
			margin: 0 auto;
			margin-top: 30px;
			flex-wrap: wrap;

			.con4_b_i {
				width: 394px;
				border-radius: 10px;
				height: 151px;
				background-color: #fff;
				margin-bottom: 30px;
				overflow: hidden;

				.con4_b_i_t {
					width: 362px;
					margin: 0 auto;
					margin-top: 20px;

					.con4_b_i_t_l {
						.con4_b_i_t_l_l {}

						.con4_b_i_t_l_c {
							font-family: Source Han Sans CN, Source Han Sans CN;
							font-weight: bold;
							font-size: 17px;
							color: #333333;
							line-height: 17px;
							text-align: left;
						}

						.con4_b_i_t_l_r {
							margin-left: 8px;
						}
					}

					.con4_b_i_t_r {
						font-family: Source Han Sans CN, Source Han Sans CN;
						font-weight: bold;
						font-size: 17px;
						color: #33CC99;
						line-height: 17px;
					}
				}

				.con4_b_i_c {
					width: 362px;
					margin: 0 auto;
					margin-top: 6px;

					.con4_b_i_c_l {
						font-family: Source Han Sans CN, Source Han Sans CN;
						font-weight: 400;
						font-size: 14px;
						color: #666666;
						line-height: 14px;
						text-align: left;
					}

					.con4_b_i_c_r {
						font-family: Source Han Sans CN, Source Han Sans CN;
						font-weight: 400;
						font-size: 14px;
						color: #666666;
						line-height: 14px;
						text-align: left;
						padding-left: 10px;
					}
				}

				.con4_b_i_b {
					width: 362px;
					margin: 0 auto;
					margin-top: 13px;

					.con4_b_i_b_i {
						padding: 6px 20px;
						background: #EEEEEE;
						border-radius: 10px;
						font-family: Source Han Sans CN, Source Han Sans CN;
						font-weight: 400;
						font-size: 11px;
						color: #666666;
						line-height: 11px;
						text-align: center;
						margin-right: 10px;
					}
				}

				.con4_b_i_bs {
					width: 362px;
					margin: 0 auto;
					margin-top: 10px;

					.con4_b_i_bs_l {
						.con4_b_i_bs_l_l {
							width: 37px;
							height: 37px;
							display: block;
						}

						.con4_b_i_bs_l_c {
							font-family: Source Han Sans CN, Source Han Sans CN;
							font-weight: 400;
							font-size: 14px;
							color: rgba(31, 31, 31, 0.9);
							line-height: 14px;
							text-align: left;
							padding-left: 10px;
						}

						.con4_b_i_bs_l_r {
							width: 22px;
							height: 20px;
							display: block;
							margin-left: 10px;
						}
					}

					.con4_b_i_bs_r {
						width: 240px;
						font-family: Source Han Sans CN, Source Han Sans CN;
						font-weight: 400;
						font-size: 13px;
						color: #C0BEBE;
						line-height: 13px;
						text-align: right;
					}
				}
			}
		}

		.con4_bs {
			width: 1240px;
			margin: 0 auto;
			margin-top: 50px;
			overflow: hidden;
			cursor: pointer;
			flex-wrap: wrap;

			.con4_bs_i {
				width: 232px;
				margin-right: 20px;
				margin-bottom: 30px;

				.con4_bs_i_t {
					width: 232px;
					height: 122px;
					display: block;
					border-radius: 10px;
				}

				.con4_bs_i_c {
					font-family: Source Han Sans CN, Source Han Sans CN;
					font-weight: bold;
					font-size: 18px;
					color: #000000;
					line-height: 18px;
					text-align: left;
					padding-top: 32px;
					padding-bottom: 12px;
				}

				.con4_bs_i_b {
					width: 100%;

					.con4_bs_i_b_l {
						width: 180px;
						font-family: Source Han Sans CN, Source Han Sans CN;
						font-weight: 400;
						font-size: 14px;
						color: #747475;
						line-height: 14px;
						text-align: left;
					}

					.con4_bs_i_b_r {
						font-family: Source Han Sans CN, Source Han Sans CN;
						font-weight: 400;
						font-size: 14px;
						color: #747475;
						line-height: 14px;
						text-align: left;
					}
				}
			}

			.con4_bs_i:nth-child(5n) {
				margin-right: 0px !important;
			}
		}

		.con4_bss {
			width: 1240px;
			margin: 0 auto;
			margin-top: 30px;
			flex-wrap: wrap;

			.con4_bss_i {
				width: 394px;
				border-radius: 10px;
				height: 136px;
				background-color: #fff;
				margin-bottom: 26px;
				overflow: hidden;

				.con4_bss_i_l {
					margin-left: 20px;

					.con4_bss_i_l_t {
						font-family: Source Han Sans CN, Source Han Sans CN;
						font-weight: bold;
						font-size: 17px;
						color: #333333;
						line-height: 17px;
						text-align: left;
						padding-top: 12px;
					}

					.con4_bss_i_l_c {
						font-family: Source Han Sans CN, Source Han Sans CN;
						font-weight: 400;
						font-size: 14px;
						color: #666666;
						line-height: 14px;
						text-align: left;
						padding-top: 14px;
					}

					.con4_bss_i_l_b {
						margin-top: 14px;
						width: 261px;
						height: 40px;
						font-family: Source Han Sans CN, Source Han Sans CN;
						font-weight: 400;
						font-size: 17px;
						color: #4E4E4E;
						line-height: 40px;
						text-align: left;

						.con4_bss_i_l_b_l {
							width: 28px;
							height: 28px;
							display: block;
						}

						.con4_bss_i_l_b_r {
							font-family: Source Han Sans CN, Source Han Sans CN;
							font-weight: 400;
							font-size: 14px;
							color: #4E4E4E;
							line-height: 14px;
							text-align: left;
							padding-left: 10px;
						}
					}
				}

				.con4_bss_i_r {
					width: 84px;
					height: 84px;
					display: block;
					position: relative;
					margin-right: 42px;
				}

				.con4_bss_i_rs {
					width: 24px;
					height: 24px;
					display: block;
					position: absolute;
					right: 12px;
					bottom: 0px;
				}
			}
		}

		.con4_bsss {
			width: 1240px;
			margin: 0 auto;
			margin-top: 40px;

			.con4_bsss_t {
				width: 100%;

				.con4_bsss_t_i {
					margin-right: 60px;
					height: 60px;

					.con4_bsss_ts {
						font-family: Source Han Sans CN, Source Han Sans CN;
						font-weight: 500;
						font-size: 18px;
						color: #727273;
						line-height: 18px;
						text-align: left;
					}
				}

				.con4_bsss_t_i_active {
					.con4_bsss_ts {
						color: #12022F !important;
						font-size: 18px;
						font-weight: 500;
					}

					.con4_bsss_line {
						width: 34px;
						margin: 0 auto;
						margin-top: 8px;
						height: 2px;
						background: #000000;
						border-radius: 0px 0px 0px 0px;
					}
				}
			}

			.con4_bsss_b {
				width: 1240px;
				margin: 0 auto;
				margin-top: 30px;

				.con4_bsss_b_t {
					font-family: Source Han Sans CN, Source Han Sans CN;
					font-weight: 400;
					font-size: 11px;
					color: #666567;
					line-height: 11px;
					text-align: left;
				}

				.con4_bsss_b_b {
					width: 1240px;
					margin: 0 auto;
					margin-top: 20px;

					.con4_bsss_b_b_l {
						width: 1240px;
						height: 575px;
					}
				}
			}
		}
	}

	.con4_i_t_l_r {
		width: 44px;
		height: 28px;
		margin-left: 8px;
		background: url('https://www.sxlgw.cn/profile/upload/xcx/95.png') no-repeat;
		background-size: 100%;
		color: #fff;
		font-size: 18px;
		line-height: 28px;
		text-align: center;
	}

	.con4_i_t_l_rs {
		width: 44px;
		height: 28px;
		margin-left: 8px;
		background: url('https://www.sxlgw.cn/profile/upload/xcx/96.png') no-repeat;
		background-size: 100%;
		color: #fff;
		font-size: 18px;
		line-height: 28px;
		text-align: center;
	}

	.con4_i_t_l_rss {
		width: 44px;
		height: 28px;
		margin-left: 8px;
		background: url('https://www.sxlgw.cn/profile/upload/xcx/97.png') no-repeat;
		background-size: 100%;
		color: #fff;
		font-size: 18px;
		line-height: 28px;
		text-align: center;
	}

	.con4_i_t_l_rsss {
		width: 44px;
		height: 28px;
		margin-left: 8px;
		background: url('https://www.sxlgw.cn/profile/upload/xcx/98.png') no-repeat;
		background-size: 100%;
		color: #fff;
		font-size: 18px;
		line-height: 28px;
		text-align: center;
	}

	.con3_i {
		width: 1194px;
		height: 672px;
		display: block;
	}

	.con3 {
		width: 1240px;
		margin: 0 auto;
		margin-top: 47px;
		overflow: hidden;
		height: 472px;

		.con3_l {
			width: 894px;
			height: 472px;
		}

		.con3_r {
			width: 350px;
			height: 472px;
			background: rgba(34, 54, 48, .8);
			cursor: pointer;

			.con3_r_i {
				width: 350px;
				height: 182px;

				.con3_r_i_l {
					width: 137px;
					height: 99px;
					display: block;
					margin-left: 20px;
				}

				.con3_r_i_r {
					font-family: Source Han Sans CN, Source Han Sans CN;
					font-weight: 500;
					font-size: 14px;
					color: #FFFFFF;
					line-height: 30px;
					text-align: left;
					padding-left: 20px;
				}
			}

			.con3_r_i_active {
				width: 350px;
				height: 182px;
				background-color: #06241B;
			}
		}
	}

	.con1 {
		width: 100%;
		height: 81px;
		background: #111111;

		.con1_l {
			width: 38px;
			height: 38px;
			display: block;
			margin-left: 58px;
		}

		.con1_c {
			font-family: Inter, Inter;
			font-size: 32px;
			color: #FFFFFF;
			line-height: 81px;
			padding-left: 9px;
		}

		.con1_r {
			font-family: Source Han Sans CN, Source Han Sans CN;
			font-weight: 500;
			font-size: 18px;
			color: #FFFFFF;
			line-height: 81px;
			padding-left: 7px;
			padding-top: 10px;
		}

		.con1_rs {
			width: 120px;
			height: 40px;
			font-size: 14px;
			text-align: center;
			line-height: 40px;
			background-color: #fff;
			color: #000;
			border-radius: 10px;
			margin-left: 80px;
			cursor: pointer;
		}
	}

	.con {
		width: 100%;
		background: url('../../assets/43.png') no-repeat;
		background-size: 100%;
		background-color: #F5FCF9;
	}

	.con2s {
		width: 100%;
		overflow: hidden;
	}

	.con2_l_b_l:focus {
		outline: none;
		/* 获得焦点时的边框 */
	}

	.con2 {
		width: 1240px;
		margin: 0 auto;
		margin-top: 48px;

		.con2_l {
			width: 923px;
			height: 80px;
			background: #FFFFFF;
			border-radius: 40px;
			border: 2px solid #33CC99;

			.con2_l_b {
				width: 913px;
				margin: 0 auto;
				background: #FFFFFF;
				border-radius: 40px;
				margin-left: 10px;

				.con2_l_b_l {
					flex: 1;
					height: 80px;
					border: none;
					margin-left: 20px;
					font-size: 26px;
				}

				.con2_l_b_r {
					width: 204px;
					height: 60px;
					font-family: Source Han Sans CN, Source Han Sans CN;
					font-weight: bold;
					font-size: 26px;
					color: #FFFFFF;
					line-height: 60px;
					text-align: center;
					background: #33CC99;
					border-radius: 30px 30px 30px 30px;
					margin-right: 10px;
					cursor: pointer;
				}
			}
		}

		.con2_r {
			.con2_r_l {
				width: 100px;
				height: 100px;
				display: block;
			}

			.con2_r_r {
				margin-left: 30px;

				.con2_r_r_t {
					font-family: Source Han Sans CN, Source Han Sans CN;
					font-weight: bold;
					font-size: 17px;
					color: #000000;
					line-height: 25px;
					text-align: center;
				}

				.con2_r_r_b {
					width: 100%;
					font-family: Source Han Sans CN, Source Han Sans CN;
					font-weight: 500;
					font-size: 18px;
					color: #B5B9B6;
					line-height: 18px;
					letter-spacing: 8px;
					text-align: center;
					padding-top: 15px;
				}
			}
		}
	}
</style>